import { CanDeactivateFn } from '@angular/router';
import { Observable, Subject } from 'rxjs';

/**
 * Interface que les composants doivent implémenter pour utiliser le guard
 */
export interface HasUnsavedChanges {
  hasUnsavedChanges: boolean;
  confirmLeave$?: Subject<boolean>;
  showLeaveConfirmation?: boolean;
}

/**
 * Guard qui empêche la navigation si des changements non sauvegardés existent
 * Déclenche une modale de confirmation dans le composant
 */
export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = (
  component,
): Observable<boolean> | boolean => {
  if (!component.hasUnsavedChanges) {
    return true;
  }

  // Afficher la modale de confirmation dans le composant
  if (
    component.confirmLeave$ &&
    component.showLeaveConfirmation !== undefined
  ) {
    component.showLeaveConfirmation = true;
    return component.confirmLeave$.asObservable();
  }

  // Fallback: confirmation native du navigateur
  return window.confirm(
    '⚠️ Vous avez des modifications non sauvegardées. Voulez-vous vraiment quitter ?',
  );
};
